import React from "react";
import styles from "./CogLoader.module.css";

interface CogLoaderProps {
  width?: number;
}

export const CogLoader: React.FC<CogLoaderProps> = ({ width = 48 }) => (
  <svg
    data-testid="cog-loader"
    className={styles.loader}
    style={{ width }}
    viewBox="0 0 167 216"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      className={styles.rect1}
      x="10"
      y="10"
      width="98"
      height="196"
      rx="49"
      fill="transparent"
      stroke="black"
      strokeWidth="20"
      strokeLinecap="round"
    />
    <rect
      className={styles.rect2}
      x="59"
      y="10"
      width="98"
      height="196"
      rx="49"
      fill="transparent"
      stroke="black"
      strokeWidth="20"
      strokeLinecap="round"
    />
  </svg>
);
